import {
  Dashboard,
  Ping,
  PasswordGenerator,
  HtpasswdPasswordGenerator,
  SpfCheck,
  HttpHeaders,
  BgpRoute,
  DNSTool
} from "@/app/dashboard";

export default [
  {
    path: "/",
    name: "dashboard",
    component: Dashboard,
    children: [
      {
        path: "ping",
        name: "PING",
        component: Ping,
        meta: "PING"
      },
      {
        path: "password-generator",
        name: "password-generator",
        component: PasswordGenerator,
        meta: "Generator haseł"
      },
      {
        path: "htpasswd-password-generator",
        name: "htpasswd-password-generator",
        component: HtpasswdPasswordGenerator,
        meta: "Generator haseł htpasswd"
      },
      {
        path: "spf-check",
        name: "spf-check",
        component: SpfCheck,
        meta: "SPF check"
      },
      {
        path: "http-headers",
        name: "http-headers",
        component: HttpHeaders,
        meta: "HTTP headers"
      },
      {
        path: "bgp",
        name: "bgp",
        component: BgpRoute,
        meta: "bgp"
      },
      {
        path: "dns-tool",
        name: "dns-tool",
        component: DNSTool,
        meta: "dns"
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/routes.js